// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_lv-1";
export var rowFirst = "_lv-3";
export var rowLast = "_lv-5";
export var rowMiddle = "_lv-4";
export var ticketListScroll = "_lv-2";
export var ticketStack = "_lv-0";